import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import ImportRefuelings from '../../components/ImportRefuelings';

export const Route = createFileRoute('/_authenticated/expenses_import/expense/import/record')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_IMPORTED_RECORD, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.expense/import/record',
        suffix: 'menu.expenseImports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ExpenseImportRecordLayout,
});

function ExpenseImportRecordLayout() {
  return (
    <>
      <ImportRefuelings />
      <Outlet />
    </>
  );
}
